const initialState = {
    Error: false,
    ErrorMsg: ''
};
export default (state = initialState, action) => {
    switch (action.type) {
        case 'SERVER_ERROR_STATE':
            return {...state,
                Error: action.errorState,
                ErrorMsg: action.errorMessage
            };

        default:
            return state;
    }
};